import styled from "styled-components";

export const Input = styled.input`
  all: unset;
  height: 52px;
  width: 100%;
  box-sizing: border-box;
  background-color: var(--cl-panel);
  border: 1px solid var(--cl-border-strong);
  border-radius: var(--cl-radius);
  margin-top: 8px;
  font-weight: 400;
  font-size: 15px;
  font-family: var(--cl-font-sans);
  padding: 0 16px;
  color: var(--cl-text);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;

  &:hover {
    border-color: var(--cl-border-strong);
  }

  &:focus {
    border-color: var(--cl-accent);
    box-shadow: 0 0 0 3px var(--cl-accent-soft);
    background-color: var(--cl-panel);
  }

  ::placeholder {
    font-weight: 400;
    font-size: 15px;
    color: var(--cl-text-faint);
    font-family: var(--cl-font-sans);
  }
`;

export const Button = styled.button`
  all: unset;
  cursor: pointer;
  height: 50px;
  width: 100%;
  max-width: 320px;
  background: var(--cl-accent);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--cl-radius);
  font-weight: 600;
  font-size: 15px;
  text-align: center;
  font-family: var(--cl-font-sans);
  color: var(--cl-on-accent);
  box-sizing: border-box;
  transition: background-color 0.18s ease, transform 0.08s ease, box-shadow 0.18s ease;

  &:hover {
    background: var(--cl-accent-hover);
    box-shadow: 0 6px 18px rgba(59, 130, 246, 0.30);
  }

  &:active {
    transform: translateY(1px);
    background: var(--cl-accent-press);
  }
`;

export const Loader = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
